import { FC } from 'react';

import { HandMetal, MoreHorizontal, Package, Truck } from 'lucide-react';

import { Button } from '../../../components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../../../components/ui/Dropdown-Menu';
import { Order } from '../../../types';

interface Props {
    order: Order;
    onConfirmOrder: (orderId: number) => void;
    onReject: (orderId: number) => void;
    onHandOver: (orderId: number) => void;
    onAddTracking: (order: Order) => void;
}

export const SalesOrderActionsDropdown: FC<Props> = ({
    order,
    onConfirmOrder,
    onReject,
    onHandOver,
    onAddTracking,
}) => {
    if (
        order.status !== 'awaiting_shipment' &&
        order.status !== 'pending' &&
        order.status !== 'paid'
    ) {
        return null;
    }

    return (
        <div className="hidden flex-shrink-0 items-center gap-2 md:block">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="icon" className="h-8 w-8">
                        <MoreHorizontal className="h-4 w-4" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    {(order.status === 'pending' ||
                        order.status === 'paid') && (
                        <DropdownMenuItem
                            className="text-green-600"
                            onClick={() => onConfirmOrder(order.id)}
                        >
                            <Package className="mr-2 h-4 w-4" />
                            Підтвердити замовлення
                        </DropdownMenuItem>
                    )}
                    {order.delivery?.method !== 'pickup' &&
                        order.status === 'awaiting_shipment' && (
                            <DropdownMenuItem
                                className="text-blue-500"
                                onClick={() => onAddTracking(order)}
                            >
                                <Truck className="mr-2 h-4 w-4" />
                                {order.delivery?.tracking_number
                                    ? 'Змінити ТТН'
                                    : 'Додати ТТН'}
                            </DropdownMenuItem>
                        )}
                    {order.delivery?.method === 'pickup' &&
                        order.status === 'awaiting_shipment' && (
                            <DropdownMenuItem
                                className="text-green-500"
                                onClick={() => onHandOver(order.id)}
                            >
                                <HandMetal className="mr-2 h-4 w-4" />
                                Передано особисто
                            </DropdownMenuItem>
                        )}
                    <DropdownMenuItem
                        className="text-destructive"
                        onClick={() => onReject(order.id)}
                    >
                        Скасувати замовлення
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};
